import gql from 'graphql-tag'

export const fetchSuggestedCartGroupedQuery = gql`

query ($ship_tos: [String], $search: String) {
  getSuggestedCarts(ship_tos: $ship_tos, search: $search) {
    items_with_classification {
      classification_title
      items {
        sku
        packaging_enable
        material_type
        image
        name
        number_of_items_on_pallet
        number_of_items_on_layer
        number_of_layers_per_pallet
        total_units
        number_of_layers
        number_of_pallets
        price_per_piece
        your_price_wo_vat
        tags {
          value
          label
          color
        }
      }
    }
    items {
      suggested_cart_total
      shipping_address {
        outlet_name
        street
        city
        postalcode
        sap_id
      }
      products {
        sku
        packaging_enable
        material_type
        image
        name
        number_of_items_on_pallet
        number_of_layers_per_pallet
        number_of_items_on_layer
        total_units
        number_of_layers
        number_of_pallets
        price_per_piece
        your_price_wo_vat
        tags {
          value
          label
          color
        }
      }
    }
  }
}
`
